import supportedLocales from "app/locales/supportedLocales.js";

export function setDocumentLang(lang) {
  document.documentElement.lang = lang;
}

export function setDocumentTitle(newTitle) {
  document.title = newTitle;
}

export const getBrowserLocale = (options = {}) => {
  const defaultOptions = { countryCodeOnly: false };

  const opt = { ...defaultOptions, ...options };

  const navigatorLocale =
    navigator.languages !== undefined
      ? navigator.languages[0]
      : navigator.language;

  if (!navigatorLocale) {
    return undefined;
  }

  return opt.countryCodeOnly
    ? navigatorLocale.trim().split(/[-_]/)[0]
    : navigatorLocale.trim();
};

export function getSupportedLocales() {
  let annotatedLocales = [];

  for (const code of Object.keys(supportedLocales)) {
    annotatedLocales.push({
      code,
      name: supportedLocales[code]
    });
  }

  return annotatedLocales;
}

export function supportedLocalesInclude(locale) {
  return Object.keys(supportedLocales).includes(locale);
}

export function getHTMLLang() {
  return document.documentElement.lang;
}
